<template>
  <div>
    <OrganismsListsVendorList :vendors="vendors" />
  </div>
</template>
<script setup>

const locale = useLocale().getLocale();

const vendors = (await useApiFetch(`/api/newVendors?currencyId=${locale.currencyId}&languageId=${locale.languageId}`)).custom.ta.vendors.items;

</script>